<template>
  <v-card :elevation="elevation" tile class="pa-0 ma-0 rounded-sm">
    <v-card-text class="pa-0">
      <v-row no-gutters>
        <v-col cols="6" align-self="center">
          <div class="layout column ma-0 justify-center align-center">
            <v-icon :size="iconSize" color="grey">{{ icon }}</v-icon>
          </div>
        </v-col>
        <v-col
          cols="6"
          align-self="center"
          class="text-center rounded-sm rounded-l-0"
          :class="[color, pading]"
          :style="backgroundColor ? `background-color: ${backgroundColor}` : ''"
        >
        <div class="headline"
        v-bind:style="{ color: textColor, fontSize: `${fontSize}px !important` }">
            {{ title }}
          </div>
          <span class="caption" v-bind:style="{ color: textColor }">{{
            subTitle
          }}</span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    icon: String,
    title: String,
    subTitle: String,
    color: String,
    textColor: {
      type: String,
      default: "white",
    },
    elevation: {
      type: Number,
      default: 2,
    },
    iconSize: {
      type: String,
      default: "56",
    },
    pading: {
      type: String,
      default: "py-3",
    },
    fontSize: {
      type: String,
      default: "25",
    },
  },
  computed: {
    backgroundColor() {
      return this.color.startsWith("#") ? this.color : "";
    },
  },
};
</script>
